import CryptoJS from "crypto-js";
const sha256LowerTrim = (s) =>
  CryptoJS.SHA256(String(s).trim().toLowerCase()).toString(CryptoJS.enc.Hex);

const normalizePhone = (phone) => String(phone).replace(/\D+/g, "");

export const pushDataLayer = (payload) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

//META
const pageViewMetaPixel = () => {
  window.fbq("track", "PageView");
};
const leadEventMetaPixel = (userData = {}) => {
  if (!window.fbq) return;
  const { email, phone, ip, userAgent, city } = userData;
  const user_data = {};
  if (email) user_data.em = [sha256LowerTrim(email)];
  if (phone) user_data.ph = [sha256LowerTrim(normalizePhone(phone))];
  if (ip) user_data.client_ip_address = ip;
  if (userAgent) user_data.client_user_agent = userAgent;
  if (city) user_data.ct = [sha256LowerTrim(city)];
  const hasUserData = Object.keys(user_data).length > 0;
  window.fbq("track", "CompleteRegistration", hasUserData ? { user_data } : {});
};
// const purchaseEventMetaPixel = (value, plan) => {
//   const payload = { currency: "USD" };
//   if (value != null && value !== "" && !Number.isNaN(Number(value))) {
//     payload.value = Number(value);
//   }
//   if (plan) {
//     payload.content_ids = [plan];
//     payload.content_type = "subscription";
//   }
//   window.fbq("track", "Purchase", payload);
// };

//GOOGLE ANALYTICS
const pageViewGoogleAnalyticsEvent = () => {
  pushDataLayer({
    event: "pageView",
  });
};
const leadGoogleAnalyticsEvent = (userData = {}) => {
  const { email, phone } = userData;
  const eventData = { event: "signup_completed", method: "email" };
  if (email || phone) {
    eventData.user_data = {};
    if (email) eventData.user_data.email = sha256LowerTrim(email);
    if (phone)
      eventData.user_data.phone_number = sha256LowerTrim(normalizePhone(phone));
  }
  pushDataLayer(eventData);
};
const purchaseGoogleAnalyticsEvent = (value, plan) => {
  const data = {
    event: "subscription_started",
    currency: "USD",
  };
  if (value != null && value !== "") data.value = value;
  if (plan) data.plan = plan;
  pushDataLayer(data);
};

//LINKEDIN INSIGHT TAG
// User data se envía en setUserDataInTracking (enhanced matching)
const leadLinkedInPixel = () => {
  if (window.lintrk) {
    window.lintrk("track", { conversion_id: 25639202 });
  }
};
const purchaseLinkedInPixel = (value) => {
  if (window.lintrk) {
    window.lintrk("track", { conversion_id: 25639210, value: value ?? 0 });
  }
};

//BING TAG MANAGER
const leadBingTagManager = () => {
  window.uetq = window.uetq || [];
  window.uetq.push("event", "signup", {});
};
const purchaseBingTagManager = (value) => {
  window.uetq = window.uetq || [];
  window.uetq.push("event", "purchase", {
    revenue_value: value,
    currency: "USD",
  });
};

export const trackingPageView = () => {
  try {
    // if (import.meta.env.VITE_IS_STAGING === "false") {
    pageViewMetaPixel();
    pageViewGoogleAnalyticsEvent();
    // }
  } catch (error) {
    console.log("Error tracking page view", error);
  }
};

export const trackingLead = (userData = {}) => {
  try {
    // if (import.meta.env.VITE_IS_STAGING === "false") {
    leadEventMetaPixel(userData);
    leadGoogleAnalyticsEvent(userData);
    leadBingTagManager();
    leadLinkedInPixel();
    // }
  } catch (error) {
    console.log("Error tracking lead", error);
  }
};

export const trackingPurchase = (value, plan) => {
  try {
    // if (import.meta.env.VITE_IS_STAGING === "false") {
    // purchaseEventMetaPixel(value, plan); // Tracking in webhook backend
    purchaseGoogleAnalyticsEvent(value, plan);
    purchaseBingTagManager(value);
    purchaseLinkedInPixel(value);
    // }
  } catch (error) {
    console.log("Error tracking purchase", error);
  }
};
